import { render } from "./CreatePreApprovedWorkloadDialog.vue?vue&type=template&id=14d83764&scoped=true"
import script from "./CreatePreApprovedWorkloadDialog.vue?vue&type=script&lang=js"
export * from "./CreatePreApprovedWorkloadDialog.vue?vue&type=script&lang=js"

import "./CreatePreApprovedWorkloadDialog.vue?vue&type=style&index=0&id=14d83764&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14d83764"]])

export default __exports__